import { fetchTags } from 'spa/action_creators/tags'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { Link } from 'react-router-dom'
import { loggedInSelector } from '../../selectors/users'
import { makeSongUrl } from 'spa/urls'
import { PreviewQueueButton2 } from 'spa/components/preview_queue_button_2'
import { TablePopover } from './table_popover'
import {
  TrackDropdownTable,
  TrackDropdownTableAllTracksRow,
  TrackDropdownTableRow,
} from 'spa/components/track_dropdown_table'
import { useDispatch, useSelector } from 'react-redux'
import { ViewSimilarButton } from 'spa/components/view_similar_button'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import styles from './styles'

export const SongVersionsPopover = ({
  songId,
  trackList,
  currentlyInQueue,
  onAddSongToQueue,
  onRemoveSongFromQueue,
  fixed = false,
  buttonIcon,
  setIsOpen,
}) => {
  const dispatch = useDispatch()
  const loggedIn = useSelector(loggedInSelector)
  const song = useSelector(state => state.songs.songsById[parseInt(songId, 10)])
  const { tags, isLoading: isLoadingTags } = useSelector(state => state.tags)
  const isMobile = useSelector(isMobileSelector)

  const onQueueButtonClick = e => {
    e.stopPropagation()
    currentlyInQueue
      ? onRemoveSongFromQueue(song)
      : onAddSongToQueue(song, trackList)
  }

  const getGenreSlug = () => {
    const genre = tags?.find(tag => tag.name === song.category)
    return genre?.slug
  }

  useEffect(() => {
    if ((!tags || tags.length === 0) && !isLoadingTags) {
      dispatch(fetchTags())
    }
  }, [dispatch, tags, isLoadingTags])

  return (
    <TablePopover
      buttonIcon={buttonIcon}
      className={classNames(
        {
          ['songVersionsPopover1']: buttonIcon === 'arrow-alt-circle-down',
          ['songVersionsPopover2']: buttonIcon === 'ellipsis-h',
        },
        styles.tablePopoverContainer
      )}
      contentClassName={classNames(styles.tablePopoverContent, {
        [styles.noMinWidth]: buttonIcon === 'ellipsis-h',
      })}
      fixed={fixed}
      setIsOpen={setIsOpen}
      style={{
        padding: '2px',
        height: '32px',
        width: isMobile ? '40px' : '32px',
        textAlign: 'center',
        marginLeft: isMobile ? '-9px' : '0px',
      }}
    >
      {buttonIcon === 'arrow-alt-circle-down' ||
      (isMobile && buttonIcon === 'ellipsis-h') ? (
        <TrackDropdownTable>
          {song.types.map(track => (
            <TrackDropdownTableRow
              change={song.changes && find(song.changes, { tid: track.tid })}
              key={track.tid}
              songId={songId}
              track={track}
              trackList={trackList}
            />
          ))}
          <TrackDropdownTableAllTracksRow
            songId={songId}
            trackList={trackList}
            tracks={song.types}
          />
        </TrackDropdownTable>
      ) : null}

      {buttonIcon === 'ellipsis-h' ? (
        <div className={styles.moreActionButtons}>
          <Link
            className={styles.moreActionButtonsLink}
            to={`${makeSongUrl(song)}#related`}
          >
            <ViewSimilarButton className={styles.moreActionButtonsIcon} />
            <FormattedMessage
              defaultMessage="View Similar"
              id="djcity.common.view_similar"
            />
          </Link>
          <Link
            className={styles.moreActionButtonsLink}
            to={`/genre/${getGenreSlug()}`}
          >
            <FontAwesomeIcon
              className={styles.moreActionButtonsIcon}
              icon="list-music"
            />
            <FormattedMessage
              defaultMessage="View Genre"
              id="djcity.common.view_genre_default"
            />
          </Link>
          <PreviewQueueButton2
            className={loggedIn ? null : styles.inactive}
            currentlyInQueue={currentlyInQueue}
            onClick={onQueueButtonClick}
          />
        </div>
      ) : null}
    </TablePopover>
  )
}

SongVersionsPopover.propTypes = {
  buttonIcon: PropTypes.string,
  currentlyInQueue: PropTypes.bool,
  fixed: PropTypes.bool,
  loggedIn: PropTypes.bool,
  onAddSongToQueue: PropTypes.func,
  onRemoveSongFromQueue: PropTypes.func,
  setIsOpen: PropTypes.func,
  songId: PropTypes.number.isRequired,
  trackList: PropTypes.string,
}
